// Static display facts for the 3-column pricing table (spec section 3,
// updated per backend billing-plays commit e00bf7b):
//   Free  $0    0 one-time / 0 always-on, unlimited AI Chat
//   Core  $49   5 one-time / 2 always-on, 300 AI Chat questions/mo
//   Pro   $199  12 one-time / 6 always-on, unlimited AI Chat (bumped 4->6 2026-08-09)
// Play Packs $25/mo, max 2 per plan (decision de Alejo 2026-07-20):
//   Growth (core) pack = +2 always-on and +2 one-time, stacks fully
//   Accelerate (pro) pack = +2 always-on and +3 one-time, stacks fully
//   (Accelerate differentiated by features + one-time, not always-on)
// Numbers here are for INSTANT first paint only; GET /billing/plans
// (plays_model.pricing_public_view) is the source of truth and
// PricingPage.jsx overlays it once it loads. Never used to compute a charge
// or a real entitlement check.

export const DISPLAY_PLANS = [
  {
    tier: 'free',
    name: 'Free',
    priceMonthly: 0,
    oneTimeIncluded: 0,
    alwaysOnIncluded: 0,
    canActivate: false,
    packAvailable: false,
    maxPacks: 0,
    chatCopy: 'Unlimited AI Chat',
    resultsHistory: 'limited',
    basicCalendar: false,
    onboarding: 'self-service',
    users: 1,
  },
  {
    tier: 'core',
    name: 'Core',
    priceMonthly: 49,
    oneTimeIncluded: 5,
    alwaysOnIncluded: 2,
    canActivate: true,
    packAvailable: true,
    packContentsKey: 'playPackCoreContents',
    maxPacks: 2,
    chatCopy: 'Up to 300 AI Chat questions per month',
    resultsHistory: 'full',
    basicCalendar: false,
    onboarding: 'self-service',
    // No users bullet on Growth: nothing enforces a seat limit today, so we
    // don't claim one either way (decision de Alejo 2026-07-19).
    users: null,
  },
  {
    tier: 'pro',
    name: 'Pro',
    priceMonthly: 199,
    oneTimeIncluded: 12,
    alwaysOnIncluded: 6,  // bumped 4->6 2026-08-09 (Alejo), matches backend plays_model.py
    canActivate: true,
    packAvailable: true,
    packContentsKey: 'playPackProContents',
    maxPacks: null, // Accelerate: unlimited packs (decision de Alejo 2026-07-20)
    chatCopy: 'Unlimited AI Chat',
    resultsHistory: 'full',
    basicCalendar: true,
    onboarding: 'assisted',
    // Honest for now: no multi-user/seat system is built (single Shopify-store
    // session, no per-person identity). "Multiple users" was unbacked; keep
    // this as "1 user" until real seats exist (decision de Alejo 2026-07-19).
    users: 1,
  },
];

export const PACK_PRICE_MONTHLY = 25;
export const DETECTED_PLAYS_COPY = 'Unlimited Detected Opportunities to Play';

// Merge live /billing/plans data over the static display facts, keyed by tier.
export function mergePublicPlans(displayPlans, apiPlans) {
  if (!Array.isArray(apiPlans) || apiPlans.length === 0) return displayPlans;
  const byTier = Object.fromEntries(apiPlans.map((p) => [p.tier, p]));
  return displayPlans.map((plan) => {
    const live = byTier[plan.tier];
    if (!live) return plan;
    return {
      ...plan,
      priceMonthly: live.price_monthly ?? plan.priceMonthly,
      oneTimeIncluded: live.one_time_included === undefined ? plan.oneTimeIncluded : live.one_time_included,
      alwaysOnIncluded: live.always_on_included ?? plan.alwaysOnIncluded,
      canActivate: live.can_activate ?? plan.canActivate,
      packAvailable: live.pack_price_monthly != null,
      packPriceMonthly: live.pack_price_monthly ?? PACK_PRICE_MONTHLY,
      packAlwaysOn: live.pack_always_on,
      packOneTime: live.pack_one_time,
      maxPacks: live.max_packs ?? plan.maxPacks,
      chatCopy: live.chat_copy ?? plan.chatCopy,
      detectedPlaysCopy: live.detected_plays_copy,
      features: live.features,
    };
  });
}
